/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesDetailController', ActivitiesDetailController);

    ActivitiesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Activities', 'Profile', 'Booking'];

    function ActivitiesDetailController($scope, $rootScope, $stateParams, previousState, entity, Activities, Profile, Booking) {
        var vm = this;

        vm.activities = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:activitiesUpdate', function(event, result) {
            vm.activities = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
